import { FC, ReactElement, ReactNode } from 'react';
import useQueryNoCache from 'utils/hooks/useQueryNoCache';
import { QueryKey } from 'components/insights/constants';
import AnalyticsApi from 'api/analytics';
import { runIfFn } from 'app/utils/run-if-fn';

type Props = {
  children: ReactElement | ((args: { isInitializing: boolean }) => ReactNode);
};

const InsightsInitializationGate: FC<Props> = (props) => {
  const initialization = useQueryNoCache(
    QueryKey.initialization(),
    async () => {
      const { isFirstTimeInAnalytics } = await AnalyticsApi.userStatus();

      if (isFirstTimeInAnalytics) {
        const { completed } = await AnalyticsApi.loadPages();

        return completed;
      }

      return true;
    },
  );

  return (
    <>
      {runIfFn(props.children, {
        isInitializing: initialization.isLoading,
      })}
    </>
  );
};
export default InsightsInitializationGate;
